import { unpurry } from "@suse-o11y/unpurry";
import { omit as omit_ } from "remeda";

export const omit = unpurry(omit_, 2);
